export const COLUMN_TO_BACKEND_FIELD: Record<string, string> = {
    name: 'name',
    longName: 'longName',
    provider: 'provider',
    type: 'type',
};
